import React, {useEffect, useState} from 'react';
import templateStyles from "./contact-template.module.css";
import {FormControl, InputLabel, MenuItem, Select, TextField} from "@mui/material";
import {isValidEmailFormat, isValidPhoneFormat} from "./input-validation";
import NavXsci from "../layout/respnsivenavigation/nav-xsci";
import FooterXsci from "../layout/footer/footer-xsci";
import emailjs from "@emailjs/browser";
import {Link, useLocation} from "react-router-dom";
import responsive from "./contact-template.responsive.module.css";
import {useTranslation} from "react-i18next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck} from "@fortawesome/free-solid-svg-icons";
import DOMPurify from 'dompurify';
import styles from "../layout/footer/footer-xsci.module.css";
import {faFacebook, faInstagram} from "@fortawesome/free-brands-svg-icons";

function ContactTemplate() {


    const location = useLocation();
    const { t, i18n } = useTranslation(); // Use the translation hook
    const currentLanguage = i18n.language; // Get current language

    const pageTitle = "Contact XSCI - Exceptional Customer Service & Web Solutions in Kanata";
    const metaDescriptionContent = "Contact XSCI for exceptional customer service and expert web development, software, and design solutions in Kanata. Get in touch with our team today for personalized support and scalable solutions.";

    useEffect(() => {
        document.title = pageTitle;

        // Set the meta description
        let metaDescription = document.querySelector("meta[name='description']") as HTMLMetaElement;

        // The content you're trying to use for the meta description
        const descriptionContent = metaDescriptionContent;

        if (metaDescription) {
            metaDescription.setAttribute("content", descriptionContent); // Correctly set the content
        } else {
            metaDescription = document.createElement("meta") as HTMLMetaElement;
            metaDescription.name = "description";
            metaDescription.content = descriptionContent;
            document.head.appendChild(metaDescription);
        }
    }, []);

    const categories = [String(t('contactPage.projectTypeService.webSite')),
        String(t('contactPage.projectTypeService.webApplication')), t('contactPage.projectTypeService.software'),
        t('contactPage.projectTypeService.other')];



    const [isLoading, setIsLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);

    const pbK = "54aSUuSgWWfvFVjM3"
    const templ = "template_ll8y93a"
    const srvc = "service_n100voe"


    useEffect(() => {
        // Change the background color when this page is loaded
        document.body.style.backgroundColor = 'white';

        // Cleanup the effect when leaving this page (optional)
        return () => {
            document.body.style.backgroundColor = ''; // Reset background color when leaving
        };
    }, [location]);

   // The value attribute is essential for a controlled component ***
    const [formData, setFormData] = useState([
        { name: 'First name', value: '', error: ''},
        { name: 'Last name', value: '', error: '' },
        { name: 'Email', value: '', error: '' },
        { name: 'Phone', value: '', error: '' },
        { name: 'Company', value: '', error: '' },
    ]);

    const [message, setMessage] = useState({ name: 'message', value: '', error: ''});
    const [category, setCategory] = useState({ name: 'Category', value: '', error: ''});

    const updateInputValueChange = (inputField: any,newValue: any) => {
        const sanitizedValue = sanitizeInput(newValue); // Apply sanitization
        setFormData(prevInputs =>
            prevInputs.map(input =>
                input.name === inputField ? { ...input, value: sanitizedValue, error: '' } : input
            )
        );
    };

    const handleMessageChange = (e: any) => {
        const update = {...message, value: e.target.value, error: ''}
        setMessage(update);
    }

    const handleCategoryChange = (e: any) => {
        const update = {...category, value: e.target.value, error: ''}
        console.log("handleCategoryChange()", update)
        setCategory(update);
    }



    // Utility function to sanitize input data
    const sanitizeInput = (input: string) => {
        // Sanitize the input strictly
        return DOMPurify.sanitize(input, {
            ALLOWED_TAGS: [], // Don't allow any tags
            ALLOWED_ATTR: [], // Don't allow any attributes
        });
    };

    // input validation
    const isValidInputSet = () : boolean => {

        console.log("inside test")
        let valid = true;
        formData.forEach(int => {
            console.log("int", int)
            if(int.value ==='' && int.name !== 'Company') {
                valid = false;
                updateInputValueChange(int, '');
                int.error = String(t('contactPage.form.errorMessageGeneral'));
            }
            if(int.name === 'Email' && int.value !== '') {
                if(!isValidEmailFormat(int.value)) {
                    valid = false;
                    updateInputValueChange(int, '');
                    int.error = String(t('contactPage.form.errorMessageEmail'));
                }
            }

            if(int.name === 'Phone' && int.value !== '') {
                if(!isValidPhoneFormat(int.value)) {
                    valid = false;
                    updateInputValueChange(int, '');
                    int.error = String(t('contactPage.form.errorMessagePhone'));
                }
            }
        })
        console.log("message before check", message)
        if(message.value === '') {
            valid = false;
            const update =  {...message, error: String(t('contactPage.form.errorMessageGeneral'))};
            console.log("update", update)
            setMessage(update)
        }

        if(category.value === '') {
            valid = false;
            const update =  {...category, error: String(t('contactPage.form.errorMessageGeneral'))};
            console.log("update", update)
            setCategory(update)
        }

        return valid;
    }

    // Send email via EmailJS
    const sendEmailData = (e: React.FormEvent) => {
        e.preventDefault();


        if (isValidInputSet()) {
            setIsLoading(true); // Show the loader when form is submitted
            // Prepare the form data as an object to be sent via EmailJS
            const emailData = {

                    user_first_name: sanitizeInput(formData.find((field) => field.name === 'First name')?.value || ''),
                    user_last_name: sanitizeInput(formData.find((field) => field.name === 'Last name')?.value || ''),
                    user_email: sanitizeInput(formData.find((field) => field.name === 'Email')?.value || ''),
                    user_phone: sanitizeInput(formData.find((field) => field.name === 'Phone')?.value || ''),
                    user_company: sanitizeInput(formData.find((field) => field.name === 'Company')?.value || ''),
                    message: sanitizeInput(message.value),
                    user_category: sanitizeInput(category.value),
            };

            console.log(emailData);

            // Send email using EmailJS service
            emailjs
                .send(srvc, templ, emailData, pbK)
                .then(
                    (result) => {
                        console.log("message result", result.text);
                        setIsLoading(false); // Hide loader
                        setIsSuccess(true); // Show success checkmark
                        setTimeout(() => {
                            window.location.reload(); // Reload page after success
                        }, 2000); // Delay before reloading
                    },
                    (error) => {
                        console.log(error.text);
                        setIsLoading(false); // Hide loader on error
                        alert('There was an error sending the email.');

                    }
                );
        }
    };

    return (
        <>
            <NavXsci/>

            <div className={`${templateStyles.page_container} ${responsive.page_container}`}>
                <div className={templateStyles.centered_content}>
                    {currentLanguage === 'en' ?
                        <h1 className={`${templateStyles.contact_title} ${responsive.contact_title}`}>
                            Let's <span style={{color: "darkturquoise", fontWeight: "bold"}}>Transform</span> Your
                            Business
                        </h1>
                        :
                        <h1 className={`${templateStyles.contact_title} ${responsive.contact_title}`}>
                            <span style={{color: "darkturquoise", fontWeight: "bold"}}>Transformons</span> Votre
                            Entreprise<span
                            style={{color: "darkturquoise"}}>!</span>
                        </h1>}

                    <div className={`${templateStyles.flex_box_container} ${responsive.flex_box_container}`}>
                        <div className={`${templateStyles.flex_item} ${responsive.flex_item}`}>
                            <p>
                                {String(t('contactPage.form.formMessage'))}
                            </p>

                            {formData.map((cat, index) => (
                                <div className={`${templateStyles.input_container}`} key={index}>
                                    <TextField
                                        className={`${templateStyles.input_field}`}
                                        label={`${t(`contactPage.formLabels.${cat.name}`)}${cat.name === 'Company' ? ` (${t('contactPage.formLabels.optional')})` : ''}`} // Use translation for the label and append "(Optional)" if it's "CompanySection"

                                        // label={`${cat.name}${cat.name === 'CompanySection' ? ' (Optional)' : ''}`} // Add "(Optional)" to the label if it's "CompanySection"
                                        variant="outlined"
                                        fullWidth={true}
                                        value={cat.value}
                                        onChange={(e) => updateInputValueChange(cat.name, e.target.value)}
                                        margin="dense"
                                        required={cat.name !== 'Company'} // Make the field required unless the name is "CompanySection"
                                        sx={{
                                            '& .MuiFormLabel-asterisk': {
                                                color: 'red', // Change the color of the asterisk to red
                                            },
                                        }}
                                    />
                                    {cat.name !== 'Company' && cat.error && <p className={`${templateStyles.error_message}`}>{cat.error}</p>}
                                </div>
                            ))}
                            <FormControl className={`${templateStyles.inquery_type} ${responsive.inquery_type}`}>
                                <div>
                                    <InputLabel
                                                id="demo-simple-select-label"
                                                className={`${templateStyles.input_label} ${responsive.input_label}`}>
                                        {String(t('contactPage.formLabels.projectType'))}
                                    </InputLabel>
                                </div>

                                <Select
                                    className={`${templateStyles.input_field}`}
                                    margin="dense"
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={category.value} // specifies the value to be sent to a server when a form is submitted.
                                    fullWidth={true}
                                    onChange={handleCategoryChange}
                                    variant={"standard"}>
                                    name="user_category" // Add name attribute
                                    {categories.map(cat => {
                                        return (
                                            <MenuItem key={cat} value={cat}>
                                                <span>{cat}</span>
                                                {/*<span>  {t(`contactPage.projectTypeService.${cat}`) as React.ReactNode}</span> /!* Wrapping text in span *!/*/}
                                            </MenuItem>
                                        )
                                    })}
                                </Select>
                            </FormControl>

                            {category.error !== '' ?
                                <p className={`${templateStyles.error_message}`}>{category.error}</p> :
                                <p></p>}
                            <textarea className={`${templateStyles.text_area}`}
                                      style={{fontWeight: 'bold'}}
                                      id="message"
                                      name="message"
                                      placeholder={ currentLanguage === 'en'? 'Write your message here...': 'Écrivez votre message ici...'}
                                      value={message.value}
                                      onChange={handleMessageChange}
                                      required>
                                </textarea>
                            {message.error !== '' ?
                                <p className={`${templateStyles.error_message}`}>{message.error}</p> : <p></p>}
                            <p>
                                {String(t('contactPage.form.privacyMessagep1'))}
                                <Link  to={'/privacy'}>{String(t('contactPage.form.privacyMessagep2'))}</Link>
                            </p>
                            <button
                                type="submit" className={`${templateStyles.submit_button}`}
                                    onClick={sendEmailData}
                                    disabled={isLoading}
                            >
                                {String(t('contactPage.form.submit'))}
                            </button>
                        </div>

                        {/* Loader and Success Modal */}
                        {(isLoading || isSuccess) && (
                            <div className={`${templateStyles.overlay}`}>
                                {isLoading ? (
                                    // <div className={`${templateStyles.loader}`}>Loading...</div>
                                    <div className={`${templateStyles.loader}`}></div>
                                ) : (
                                    <div  className={`${templateStyles.success_check} ${responsive.success_check}`}>
                                        {<FontAwesomeIcon icon={faCheck} className={`${templateStyles.success_icon}`}/>}
                                        Email Sent Successfully
                                    </div>
                                )}
                            </div>
                        )}

                        {/*MORE WAYS TO CONNECT*/}
                        <div className={`${templateStyles.flex_item} ${responsive.flex_item}`}>
                            <h2 className={`${templateStyles.key_feature_title}`}>{String(t('contactPage.moreWaysToConnect.title'))}</h2>
                            <h2 style={{marginTop: "60px"}}>{String(t('contactPage.moreWaysToConnect.generalInquiries'))}</h2>
                            {/*<FontAwesomeIcon icon={faEnvelope}/>*/}
                            <p className="fw-bold fs-2 fs-lg-4">Ottawa: 613-468-7320</p>
                            <p className="fw-bold fs-2 fs-lg-4">Montreal: 514-512-6208</p>

                            <p style={{fontSize: "30px", fontWeight: "bold"}}>info@xsci.ca</p>
                            <h2 style={{marginTop: "40px"}}>{String(t('contactPage.moreWaysToConnect.followUs'))}</h2>
                            <h2>{String(t('contactPage.moreWaysToConnect.joinConvo'))} &nbsp;</h2>
                            <div>
                                <a href="https://www.facebook.com/people/XSCI/61573466566374/"
                                   className={`${styles.follow_us_link} ${responsive.follow_us_link}`}
                                   target="_blank"
                                   rel="noopener noreferrer">
                                    <FontAwesomeIcon
                                        icon={faFacebook}
                                        style={{fontSize: "45px", color: "#071c3d", cursor: "pointer"}}
                                    />
                                </a>
                                <a href="https://instagram.com/xscisolutions"
                                   className={`${styles.follow_us_link} ${responsive.follow_us_link}`}
                                   target="_blank"
                                   rel="noopener noreferrer">
                                    <FontAwesomeIcon
                                        icon={faInstagram}
                                        style={{
                                            fontSize: "45px",
                                            color: "#071c3d",
                                            cursor: "pointer",
                                            marginLeft: "15px"
                                        }}
                                    />
                                </a>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <FooterXsci/>
        </>
    );
}

export default ContactTemplate;
